// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
export type PrimerMessage = {
  id: string;
  minimumVersion: string;
  nativeMessagingHostID: string;
  selectedContractVersion: string;
};

export function isPrimerMessage(value: unknown): value is PrimerMessage {
  let message = value as PrimerMessage;
  return message.id !== undefined 
    && message.minimumVersion !== undefined 
    && message.nativeMessagingHostID !== undefined 
    && message.selectedContractVersion !== undefined;
}

export type PrimerMessageResponse = {
  success: true;
  id: string;
} | {
  success: false;
  id: string;
  reason: "invalidContract" | "outdatedExtension" | "unknown";
  message: string;
};